export default __webpack_public_path__ + "static/media/people-2.e6a5b7bc.svg";